// community
const Listcommunity = () => import('@/views/setting/community')
const Formcommunity = () => import('@/views/setting/community/form')

export default {
    path: 'community',
    redirect: '/community',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'community',
            component: Listcommunity,
            meta: {
                link: 'community',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Community', active: true },
                ],
                pageTitle: 'Community'
            }
        },
        {
            path: 'add',
            name: 'addcommunity',
            component: Formcommunity,
            meta: {
                link: 'community',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Community', url: '/community' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Community'
            }
        },
        {
            path: 'edit/:id',
            name: 'editcommunity',
            component: Formcommunity,
            meta: {
                link: 'community',
                breadcrumb: [
                    { title: 'Setting', active: true },
                    { title: 'Community', url: '/community' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Community'
            }
        },
    ]
}